import {
  BookOpen,
  Gem,
  ShieldCheck,
  Globe2,
  Briefcase,
  ListChecks,
} from "lucide-react";
import { WHY_ANDERSON } from "../../data/homeData";

const iconMap = {
  book: BookOpen,
  diamond: Gem,
  shield: ShieldCheck,
  globe: Globe2,
  briefcase: Briefcase,
  tasks: ListChecks,
};

const WhyAnderson = () => {
  return (
    <section id="about" data-testid="why-anderson-section" className="py-20 bg-white">
      <div className="ac-container">
        <div className="text-center mb-14">
          <div className="eyebrow">Why Choose Us</div>
          <h2 className="section-heading mt-3" data-testid="why-anderson-heading">
            WHY Anderson?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {WHY_ANDERSON.map((item, i) => {
            const Icon = iconMap[item.icon] || BookOpen;
            return (
              <div
                key={item.title}
                className="lift bg-white border border-[var(--ac-line)] rounded-xl p-7 flex flex-col items-center text-center gap-4"
                data-testid={`why-card-${i}`}
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="w-16 h-16 rounded-xl bg-[#e3eaf4] flex items-center justify-center text-[var(--ac-royal)] mx-auto">
                  <Icon className="w-8 h-8" strokeWidth={1.6} />
                </div>
                <h3 className="text-[20px] font-bold text-[var(--ac-ink)] leading-snug">
                  {item.title}
                </h3>
                <p className="text-[var(--ac-muted)] text-[15px] leading-relaxed">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyAnderson;
